export default "/images/cloud-snow.svg?bead1037c066e9058830127ecbfee5b6";